import React, { useMemo, useState } from 'react'
import { Popover, Spin } from 'antd'
import Icon from 'meinian-package/src/component/icon'
import NestMenu from '../../../component/nestMenu'
import styles from './index.module.less'

/**
 * trigger popover | click 代表这个点击后的行为
 */

const NumberInfoCard = ({ menu, item, text, trigger = 'popover', value, onClick, onPopoverVisible, loading }) => {
  const total = useMemo(() => menu.sum, [menu.sum])
  const content = (
    <div style={{ width: '240px' }}>
      <Spin spinning={loading}>
        <div className="analysis-overview-number-popover-content" style={{ minHeight: '120px' }}>
          {menu?.inspirationParticulars?.length ? <NestMenu
            value={null}
            menu={menu?.inspirationParticulars}
            style={{ minWidth: '220px' }}
          /> : <div style={{ width: '100%', textAlign: 'center', color: 'var(--m-text-4)', }}>暂无数据</div>}
        </div>
      </Spin>
      <div className="analysis-overview-number-popover-footer">
        <span className="analysis-overview-number-popover-footer-text">总计</span>
        <span className="analysis-overview-number-popover-footer-number">{total}</span>
      </div>
    </div>
  )
  const behavior = useMemo(() => ({
    text,
    popover: <Popover
      overlayClassName="analysis-overview-number-card-popover"
      content={content}
      title="灵感集采集详情"
      trigger="click"
      placement="bottomLeft"
      onVisibleChange={(val) => onPopoverVisible(val)}
      getPopupContainer={(triggerNode) => triggerNode.parentElement || document.body}
    >
      <span style={{ cursor: 'pointer' }}>{text}<Icon type="m-Vxing_you" /></span>
    </Popover>,
    click: <span onClick={onClick} style={{ cursor: `${onClick ? 'pointer' : 'default'}` }}>
      {text}<Icon type="m-Vxing_you" />
    </span>
  }), [menu, item, loading])

  return (<div className="analysis-overview-number-card">
    <div className="analysis-overview-number-card-number">{Number(value).toLocaleString()}</div>
    <div className="analysis-overview-number-card-text">
      {trigger ? behavior[trigger] : text}
    </div>
  </div>)
}

export default ({ style, onClick, title, option = [], loading = false, fetchData }) => {
  const [menu, setMenu] = useState({})
  const [infoCardLoading, setInfoCardLoading] = useState(false)

  const transform = (data) => {
    data?.forEach(i => {
      i.name = i.inspirationName
      i.value = i.count
      i.id = i.inspirationId
      i.children = i.childInspirations
      if (i.children.length) {
        transform(i.children)
      }
    })
  }

  const _onPopoverClick = async (val, item) => {
    if (!val) {
      setMenu({})
      return
    }
    try {
      setInfoCardLoading(true)
      const result = await fetchData(item.params)
      transform(result?.inspirationParticulars)
      setMenu({ ...result })
    } catch (error) {
      setInfoCardLoading(false)
    } finally {
      setInfoCardLoading(false)
    }
  }

  return (<div className={styles['meinian-analysis-overview']} style={style}>
    <div className="analysis-overview-title">{title}</div>
    <Spin spinning={loading}>
      <div className="analysis-overview-number">
        {
        option.map((item, index) => <NumberInfoCard
          menu={menu}
          item={item}
          text={item.name}
          value={item.number}
          trigger={item.trigger}
          loading={infoCardLoading}
          onPopoverVisible={(val) => _onPopoverClick(val, item)}
          onClick={() => item.trigger === 'click' && onClick?.(index, '重复采集')}
        />)
      }
      </div>
    </Spin>
  </div>)
}
